import React from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmAlert from '../../components/alert/ConfirmAlert';

type Props = {
  open: boolean;
  onClose: () => void;
};

const PremiumOnlyAlert: React.FC<Props> = ({ open, onClose }) => {
  const navigate = useNavigate();
  if (!open) return null;

  return (
    <ConfirmAlert
      title="프리미엄 회원만 이용 가능한 상품입니다."
      desc="요금제를 업그레이드하고 더 자유롭게 땅집고옥션 서비스를 이용해보세요!"
      grayButtonText="닫기"
      blueButtonText="요금제 업그레이드"
      onGrayClick={() => navigate('/')}
      onBlueClick={() => {
        navigate('/payment/plan');
        onClose();
      }}
      onClose={onClose}
    />
  );
};

export default PremiumOnlyAlert;
